(function () {
    const SHOPIFY_CART_BASE = "https://rc-exclusive.flaviar.com/cart/";;
    const CLIPBOARD_MSG_ID = "clipboard-message";

    // Utility: get or create message element next to the button
    function getMessageElement(button) {
        let el = document.getElementById(CLIPBOARD_MSG_ID);
        if (el) return el;

        // If not present, create one next to the clicked button
        el = document.createElement("span");
        el.id = CLIPBOARD_MSG_ID;
        el.style.display = "none";
        el.style.marginLeft = "10px";
        el.style.fontSize = "0.9rem";
        el.style.verticalAlign = "middle";
        if (button && button.parentNode) {
            button.parentNode.appendChild(el);
        } else {
            document.body.appendChild(el);
        }
        return el;
    }

    function showMessage(button, text, success = true) {
        try {
            const el = getMessageElement(button);
            el.textContent = text;
            el.style.color = success ? "lightgrey" : "grey";
            el.style.display = "inline-block";
            clearTimeout(el._hideTimer);
            el._hideTimer = setTimeout(() => {
                el.style.display = "none";
                el.textContent = "";
            }, 3000);
        } catch (e) {
            // As a last resort, log
            console.log("[share-cart] message:", text);
        }
    }

    async function copyToClipboard(link, button) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(link);
                showMessage(button, "Sharing link copied to your clipboard!", true);
                console.log("[share-cart] Copied to clipboard:", link);
                return true;
            } catch (err) {
                console.warn("[share-cart] Clipboard write failed:", err);
                showMessage(button, "Automatic copy failed — link printed to console.", false);
                console.log("[share-cart] Link (manual copy):", link);
                return false;
            }
        } else {
            showMessage(button, "Clipboard unsupported. Link printed to console.", false);
            console.log("[share-cart] Link (no clipboard):", link);
            return false;
        }
    }

    async function buildPermacartLinkFromShopifyCart() {
        const response = await fetch("/cart.js", { credentials: "same-origin" });
        if (!response.ok) throw new Error("Failed to fetch /cart.js: " + response.status);
        const cart = await response.json();
        if (!cart.items || cart.items.length === 0) return null;
        const str = cart.items.map(i => `${i.id}:${i.quantity}`).join(",");
        return SHOPIFY_CART_BASE + str;
    }

    // Main handler (delegated)
    async function handleShareCartClick(event) {
        const button = event.target.closest("#share-cart");
        if (!button) return; // not our button

        event.preventDefault();
        event.stopPropagation();

        // Avoid multiple concurrent clicks
        if (button._working) {
            console.log("[share-cart] already working...");
            return;
        }
        button._working = true;
        const originalDisabled = button.disabled;
        button.disabled = true;
        showMessage(button, "Generating link...", true);
        console.log("[share-cart] click detected — generating...");

        try {
            const permalink = await buildPermacartLinkFromShopifyCart();
            if (!permalink) {
                showMessage(button, "Your cart is empty. No link generated.", false);
                console.log("[share-cart] cart empty");
                return;
            }

            // Try native share first
            if (navigator.share) {
                try {
                    await navigator.share({ url: permalink });
                    showMessage(button, "Cart link shared!", true);
                    console.log("[share-cart] shared with navigator.share:", permalink);
                    return;
                } catch (shareErr) {
                    console.warn("[share-cart] navigator.share failed, falling back to clipboard:", shareErr);
                    // continue to clipboard fallback
                }
            }

            // Clipboard fallback
            await copyToClipboard(permalink, button);

        } catch (err) {
            console.error("[share-cart] Error creating permacart link:", err);
            showMessage(button, "Error generating link. See console for details.", false);
        } finally {
            button.disabled = originalDisabled;
            button._working = false;
        }
    }

    // Attach delegated click once
    function init() {
        // Guard double-init
        if (window.__pcdapp_share_cart_initialized) return;
        window.__pcdapp_share_cart_initialized = true;

        // Use capture false; allow stopPropagation in handler to keep other flows unaffected
        document.addEventListener("click", handleShareCartClick, false);

        // Helpful console message
        console.log("[share-cart] event-delegation handler installed");
    }

    // Initialize as soon as possible
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
